const closeapprove = {
    path: 'closeapprove',
    component: resolve => require(['@/pages/admin/riskMerchantHandle/closeapprove'], resolve)
}
export default closeapprove